import { SectionHeading } from "~/components/DetailsPage/components";
import { Box, Grid, Typography } from "@mui/material";
import { CvssScoreBox } from "~/components/vulnerabilities";
import { Stat } from "~/components/DetailsPage/components/Stats/Stats";
import { SoftwareStats } from "./SoftwareStats";
import { SoftwareSources } from "./SoftwareSources";
import { SoftwareRiskFactors } from "./SoftwareRiskFactors";
import { SoftwareDetailsFindingsNode } from "~/pages/inventory/components/AssetSoftwareDetails/types";
import { Remediation } from "~/components/Remediation/Remediation";

interface SoftwareDescriptionProps {
  stats: Stat[];
  software: SoftwareDetailsFindingsNode;
  assetMrn: string;
}

export const SoftwareDescription = ({
  stats,
  software,
  assetMrn,
}: SoftwareDescriptionProps) => {
  return (
    <Box id="description">
      <SectionHeading heading="Description" />
      <Typography textTransform="uppercase" fontWeight={700} mb={1}>
        Summary
      </Typography>
      <Grid container spacing={3}>
        <Grid size={9}>
          <SoftwareStats stats={stats} />
          {/*<SoftwareSummary description={software.description} />*/}
          <SoftwareSources />
        </Grid>
        <Grid size={3}>
          <CvssScoreBox
            id="software-cvss-score-box"
            value={software.cvss.value}
            sx={{ mx: "auto" }}
          />
        </Grid>
      </Grid>
      <Remediation
        scopeMrn={assetMrn}
        isAssetContext
        packages={[
          {
            name: software.packageName || "",
          },
        ]}
      />
      <SoftwareRiskFactors software={software} />
    </Box>
  );
};
